












import { Component, Vue, Prop } from 'vue-property-decorator'
import InputCheckbox from '@/components/Utils/form/checkbox/element/InputCheckbox.vue'

@Component({
  components: {
    InputCheckbox
  }
})
export default class Checkbox extends Vue {
  @Prop() name!: string
  @Prop() label!: string
  @Prop() disabled!: boolean
  @Prop() value!: boolean

  change (checked: boolean) {
    this.$emit('input', checked)
    this.$emit('change', checked)
  }
}
